import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const ExternalLink = styled.a`
  display: block;
  height: 65px;
`

const InternalLink = styled( Link )`
  display: block;
  height: 65px;
`

const LineItem = styled.li`
  line-height: 20px !important;
  & > span {
    padding-right: 40px;
  }
`

const MenuItem = ( { href, 'icon': Icon, text, isExternal } ) => {
  if ( isExternal ) {
    return (
      <ExternalLink
        data-testid={ `a-h-${text}` }
        href={ href }
      >
        <LineItem
          data-testid={ `li-h-${text}` }
        >
          {Icon && <Icon />}
          <span>{ text }</span>
        </LineItem>
      </ExternalLink>
    )
  } else {
    return (
      <InternalLink
        data-testid={ `a-h-${text}` }
        to={ href }
      >
        <LineItem
          data-testid={ `li-h-${text}` }
        >
          {Icon && <Icon />}
          <span>{ text }</span>
        </LineItem>
      </InternalLink>
    )
  }
}

MenuItem.propTypes = {
  'href': PropTypes.string.isRequired,
  'icon': PropTypes.oneOf( [ PropTypes.elementType, null ] ).isRequired,
  'isExternal': PropTypes.bool,
  'text': PropTypes.string.isRequired,
}

MenuItem.defaultProps = {
  'isExternal': true
}

export default MenuItem
